import { inheritsLoose as _inheritsLoose, defineProperty as _defineProperty, assertThisInitialized as _assertThisInitialized, objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import { mergeCssModules, mapToCssModules } from '@emoney/kyber-helpers';
import classNames$1 from 'classnames';
import React__default, { Component } from 'react';
import debounce$1 from 'lodash/debounce';
import { withAnalytics } from '@emoney/kyber-analytics';
import { keyboard } from '@emoney/utils';
import 'prop-types';
import defaultCssModule from './less/button.module.less.js';
import buttonAnalytics from './button.analytics.js';

var defaultProps = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onClick: function onClick(event) {},
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onKeyDown: function onKeyDown(event) {},
  disabled: false,
  primary: false,
  link: false,
  danger: false,
  fullWidth: false,
  type: 'button',
  innerRef: function innerRef() {},
  large: false,
  clickDebounceTime: 0,
  active: false,
  analytics: buttonAnalytics
};

/**
 * Buttons are utilized when an action is being performed (i.e. search, download, submit,
 * add, etc.), whereas links perform navigational functions. This rule should be considered
 * when deciding whether or not a button is appropriate to use. While buttons are only 36px
 * tall, the padding around it should make the tappable area at least 48px (ensuring it’s
 * touch friendly).
 */
var Button = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Button, _Component);

  function Button() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "button", void 0);

    _defineProperty(_assertThisInitialized(_this), "state", {
      active: _this.props.active
    });

    _defineProperty(_assertThisInitialized(_this), "saveRef", function (ref) {
      _this.props.innerRef(ref);

      _this.button = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (event) {
      if (keyboard.isEnter(event) || keyboard.isSpace(event)) {
        _this.setState({
          active: true
        });
      }

      _this.props.onKeyDown(event);
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickAction", function (event) {
      _this.setState({
        active: false
      });

      _this.props.onClick(event);
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickActionDebounced", debounce$1(_this.handleClickAction, _this.props.clickDebounceTime, {
      leading: true,
      trailing: false
    }));

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
      // Safari doesn't focus buttons on click so we are doing it manually
      _this.focus();

      if (_this.props.clickDebounceTime === 0) {
        _this.handleClickAction(event);
      } else {
        event.persist();

        _this.handleClickActionDebounced(event);
      }
    });

    return _this;
  }

  var _proto = Button.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.active !== this.props.active) {
      this.setState({
        active: this.props.active
      });
    }
  };

  _proto.focus = function focus() {
    this.button && this.button.focus();
  };

  _proto.render = function render() {
    var _this$props = this.props,
        hover = _this$props.hover,
        focusProp = _this$props.focus,
        primary = _this$props.primary,
        danger = _this$props.danger,
        link = _this$props.link,
        fullWidth = _this$props.fullWidth,
        large = _this$props.large,
        id = _this$props.id,
        className = _this$props.className,
        children = _this$props.children,
        innerRef = _this$props.innerRef,
        onKeyDown = _this$props.onKeyDown,
        onClick = _this$props.onClick,
        clickDebounceTime = _this$props.clickDebounceTime,
        analytics = _this$props.analytics,
        cssModuleProp = _this$props.cssModule,
        active = _this$props.active,
        restProps = _objectWithoutPropertiesLoose(_this$props, ["hover", "focus", "primary", "danger", "link", "fullWidth", "large", "id", "className", "children", "innerRef", "onKeyDown", "onClick", "clickDebounceTime", "analytics", "cssModule", "active"]);

    var cssModule = mergeCssModules(cssModuleProp, defaultCssModule);
    var classes = mapToCssModules(classNames$1('btn', {
      hover: hover,
      active: this.state.active,
      focus: focusProp,
      'btn-primary': primary,
      'btn-danger': danger,
      'btn-link': link,
      'btn-default': !(primary || danger || link),
      'btn-block': fullWidth,
      'btn-lg': large
    }), cssModule);
    return /*#__PURE__*/React__default.createElement("button", _extends({
      id: id,
      className: classNames$1(classes, className),
      ref: this.saveRef,
      onClick: this.handleClick,
      onKeyDown: this.handleKeyDown
    }, restProps), children);
  };

  return Button;
}(Component);

_defineProperty(Button, "displayName", 'Button');

_defineProperty(Button, "defaultProps", defaultProps);

var Button$1 = withAnalytics(Button);

export default Button$1;
export { Button };
